module.exports = __webpack_public_path__ + "img/necesitas_one.4cb6fa14.png";